import {memo} from "react";
import {useDispatch, useSelector} from "react-redux";

import {RequestState} from "@pg-mono/request-state";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../../app/rp_reducer";
import {setActivePoiRoute} from "../../../maps/actions/set_poi_travel_directions";
import {LocationPoisSummary} from "../../../maps/components/LocationPoisSummary";
import {hitGtmBusRouteClick} from "../../../maps/tracking/routes_gtm_events";
import {trackAmplitudePoiClick} from "../../../maps/tracking/track_amplitude_poi_click";
import {IPoi} from "../../../maps/types/IPoi";
import {IPublicTransportRoute} from "../../../maps/types/IPublicTransportRoute";
import {TransportPoiType} from "../../../maps/types/PoiType";
import {getHasCountryPois} from "../../../maps/utils/get_has_country_pois";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {trackAmplitudeOfferExpandSection} from "../../tracking/amplitude/track_amplitude_offer_expand_section";
import {IOfferDetail} from "../../types/IOfferDetail";
import {OfferViewSectionTracker} from "./OfferViewSectionTracking";

interface IProps {
    offer: IOfferDetail | IPropertyDetailOffer;
    nearbyTransportPois?: Record<TransportPoiType, IPoi[]> | null;
    isTransportPoiLoading?: boolean;
    isRoutesLoading?: boolean;
    propertyId?: number;
    trackOfferSectionEvents?: boolean;
    onTransportRoutesExpand?: () => void;
    routes?: {
        busRoutes: IPublicTransportRoute[] | null;
        railwayRoutes: IPublicTransportRoute[] | null;
        subwayRoutes: IPublicTransportRoute[] | null;
        tramRoutes: IPublicTransportRoute[] | null;
    };
}

export const OfferDetailLocationSummary = memo((props: IProps) => {
    const {nearbyTransportPois, isTransportPoiLoading, isRoutesLoading, routes} = props;
    const dispatch = useDispatch();

    const poisStats = useSelector((state: IRPStore) => state.offerDetail.poisStats);
    const poisStatsRequest = useSelector((state: IRPStore) => state.offerDetail.poisStatsRequest);
    const activePoiRoute = useSelector((state: IRPStore) => state.maps.travelDirections.activePoiRoute);

    const hasNearbyTransportPois = Boolean(nearbyTransportPois && Object.values(nearbyTransportPois).some((pois) => pois.length > 0));

    const onTransportRouteClick = (poiRoute: IPublicTransportRoute) => {
        trackAmplitudePoiClick({
            location: props.propertyId != null ? "property_page" : "investment_page",
            route: poiRoute,
            itemId: props.offer.id,
            propertyId: props.propertyId ?? null
        });
        dispatch(setActivePoiRoute(poiRoute.id === activePoiRoute?.id ? null : poiRoute));
        hitGtmBusRouteClick();
    };

    const isPoisStatsLoading = poisStatsRequest === RequestState.None || poisStatsRequest === RequestState.Waiting;

    return (
        <>
            {props.trackOfferSectionEvents && hasNearbyTransportPois && getHasCountryPois(props.offer.region.country) && (
                <OfferViewSectionTracker itemId={props.offer.id} sectionName="public_transport" />
            )}
            <LocationPoisSummary
                dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OFFER_PUBLIC_TRANSPORT_SECTION}
                country={props.offer.region.country}
                nearbyTransportPois={nearbyTransportPois}
                isTransportPoiLoading={isTransportPoiLoading}
                isPoisStatsLoading={isPoisStatsLoading}
                isRoutesLoading={isRoutesLoading}
                nearestPoisCount={poisStats?.poi?.nearest_pois_count}
                routes={routes}
                activePoiRoute={activePoiRoute}
                onTransportRouteClick={onTransportRouteClick}
                onTransportRoutesExpand={
                    props.trackOfferSectionEvents
                        ? () => trackAmplitudeOfferExpandSection({sectionName: "public_transport", itemId: props.offer.id})
                        : props.onTransportRoutesExpand
                }
            />
        </>
    );
});
import {memo} from "react";
import {useDispatch, useSelector} from "react-redux";

import {RequestState} from "@pg-mono/request-state";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../../app/rp_reducer";
import {setActivePoiRoute} from "../../../maps/actions/set_poi_travel_directions";
import {LocationPoisSummary} from "../../../maps/components/LocationPoisSummary";
import {hitGtmBusRouteClick} from "../../../maps/tracking/routes_gtm_events";
import {trackAmplitudePoiClick} from "../../../maps/tracking/track_amplitude_poi_click";
import {IPoi} from "../../../maps/types/IPoi";
import {IPublicTransportRoute} from "../../../maps/types/IPublicTransportRoute";
import {TransportPoiType} from "../../../maps/types/PoiType";
import {getHasCountryPois} from "../../../maps/utils/get_has_country_pois";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {trackAmplitudeOfferExpandSection} from "../../tracking/amplitude/track_amplitude_offer_expand_section";
import {IOfferDetail} from "../../types/IOfferDetail";
import {OfferViewSectionTracker} from "./OfferViewSectionTracking";

interface IProps {
    offer: IOfferDetail | IPropertyDetailOffer;
    nearbyTransportPois?: Record<TransportPoiType, IPoi[]> | null;
    isTransportPoiLoading?: boolean;
    isRoutesLoading?: boolean;
    propertyId?: number;
    trackOfferSectionEvents?: boolean;
    onTransportRoutesExpand?: () => void;
    routes?: {
        busRoutes: IPublicTransportRoute[] | null;
        railwayRoutes: IPublicTransportRoute[] | null;
        subwayRoutes: IPublicTransportRoute[] | null;
        tramRoutes: IPublicTransportRoute[] | null;
    };
}

export const OfferDetailLocationSummary = memo((props: IProps) => {
    const {nearbyTransportPois, isTransportPoiLoading, isRoutesLoading, routes} = props;
    const dispatch = useDispatch();

    const poisStats = useSelector((state: IRPStore) => state.offerDetail.poisStats);
    const poisStatsRequest = useSelector((state: IRPStore) => state.offerDetail.poisStatsRequest);
    const activePoiRoute = useSelector((state: IRPStore) => state.maps.travelDirections.activePoiRoute);

    const hasNearbyTransportPois = Boolean(nearbyTransportPois && Object.values(nearbyTransportPois).some((pois) => pois.length > 0));

    const onTransportRouteClick = (poiRoute: IPublicTransportRoute) => {
        trackAmplitudePoiClick({
            location: props.propertyId != null ? "property_page" : "investment_page",
            route: poiRoute,
            itemId: props.offer.id,
            propertyId: props.propertyId ?? null
        });
        dispatch(setActivePoiRoute(poiRoute.id === activePoiRoute?.id ? null : poiRoute));
        hitGtmBusRouteClick();
    };

    const isPoisStatsLoading = poisStatsRequest === RequestState.None || poisStatsRequest === RequestState.Waiting;

    return (
        <>
            {props.trackOfferSectionEvents && hasNearbyTransportPois && getHasCountryPois(props.offer.region.country) && (
                <OfferViewSectionTracker itemId={props.offer.id} sectionName="public_transport" />
            )}
            <LocationPoisSummary
                dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OFFER_PUBLIC_TRANSPORT_SECTION}
                country={props.offer.region.country}
                nearbyTransportPois={nearbyTransportPois}
                isTransportPoiLoading={isTransportPoiLoading}
                isPoisStatsLoading={isPoisStatsLoading}
                isRoutesLoading={isRoutesLoading}
                nearestPoisCount={poisStats?.poi?.nearest_pois_count}
                routes={routes}
                activePoiRoute={activePoiRoute}
                onTransportRouteClick={onTransportRouteClick}
                onTransportRoutesExpand={
                    props.trackOfferSectionEvents
                        ? () => trackAmplitudeOfferExpandSection({sectionName: "public_transport", itemId: props.offer.id})
                        : props.onTransportRoutesExpand
                }
            />
        </>
    );
});
